export default __webpack_public_path__ + "static/systems-26191ec287836599f5766e6a3555ad64.png";